export default __webpack_public_path__ + "ca69088a0581528303c1c68bf36eb9c3.svg";